import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogButton,
} from '@rmwc/dialog';

const DisclosureModal = observer(function DisclosureModal({ store }) {
  return (
    <Dialog
      open={store.disclosureModalOpen}
      onClose={store.disclosureModalClose}
    >
      <DialogTitle>Realogy Military Rewards</DialogTitle>
      <DialogContent>
        *The cash back bonus is offered in most states. In some states a gift
        card or commission reduction at closing may be provided in lieu of the
        cash back bonus. The program is not available for employer- sponsored
        relocations or transactions in Iowa or outside the United States. The
        cash back bonus is not available in Alaska, Kansas, Oklahoma, and
        Tennessee. In Mississippi, New Jersey, and Oregon, a commission
        reduction may be available at closing. The cash back bonus is only
        available with the purchase and/or sale of your home through the use of
        a participating program real estate agent who is introduced to you by
        PCSgrades. The actual amount you receive is based on the purchase and/or
        sale price of your home, and the real estate commission negotiated
        between you and your assigned program real estate agent. The program
        award is not available in certain transactions with restricted agent
        commissions (including many new construction, For Sale by Owner, or For
        Sale by iBuyer transactions) and shall not exceed the amount of the
        co-operative brokerage (referral) fee paid by the program agent/broker
        to PCSgrades. Your assigned agent can help you identify transactions
        where the award would not be available. Other terms and conditions may
        apply. This is not a solicitation if you are already represented by a
        real estate broker. Please check with a program Customer Service
        Representative for details. Program terms and conditions are subject to
        change at any time without notice. Additional terms, conditions, and
        restrictions apply. PCSgrades fully supports the principles of the Fair
        Housing Act and the Equal Opportunity Act.
      </DialogContent>
      <DialogActions>
        <DialogButton action="close">Close</DialogButton>
      </DialogActions>
    </Dialog>
  );
});

export default DisclosureModal;
